
import * as THREE from 'three';
import * as marietta from '../../..';
import { mm2D, pix2D, Unit } from '../../graphicLibs/util/unit';
import { PointInfo } from '../../WalltoFittingInfo';
import { Point } from '../../graphicLibs/math/Point';
import { BUILDING_TYPE_MANSION, BUILDING_TYPE_HOUSE } from '../../../webcad/Constants';

type shapeType =  {x: number, y: number, wall_type: number};

export class AddWall2D {

    constructor(private buildingType: number) {
        ;
    }

    /**
     * 2D図面追加（壁）
     * */
    public execute(wallList: number[], pointList: PointInfo[], floor: number): void {

        const center2D = new THREE.Vector2(marietta.webcad.WebCADGlobal.LAYER_SIZE_W/2, marietta.webcad.WebCADGlobal.LAYER_SIZE_H/2);
        const walls: marietta.webcad.collection.ItemInfoCollection[] = [];
        if (this.buildingType == BUILDING_TYPE_MANSION) {
            /** マンション **/
            for (let i = 0; i < wallList.length; i++) {
                const index = wallList[i];
                if (index % 2 == 1 || pointList[index].isDelete) continue; // 奇数 or 削除対象
                const info: any = {};
                info.f = floor;
                info.id = 'wal01_01';
                info.guid = marietta.webcad.WebCADGlobal.getGuid();
                info.dotList = [];
                info.dotList.push(this.createDotList(pointList[index].point, NaN));
                info.dotList.push(this.createDotList(pointList[Point.nextPoint(index)].point, NaN));
                info.shape = this.createShape(pointList, index, Point.nextPoint(index));
                walls.push(info);
            }

            marietta.webcad.util.WebcadJSONParser.reproduceWallItem(walls);
            
        } else {
            /** 戸建て **/
            for (let i = 0; i < wallList.length; i++) {
                const index = wallList[i];
                if (index % 2 == 1 || pointList[index].isDelete) continue; // 奇数 or 削除対象
                const info: any = {};
                info.id = 'fit01_01';
                info.f = floor;
                info.guid = marietta.webcad.WebCADGlobal.getGuid();

                /** 角度 **/
                info.rotation = this.getRotate(pointList, index);

                /** 位置 **/
                const dir = pointList[Point.nextPoint(index)].point.clone().sub(pointList[index].point);
                const pix = Unit.convertMmtoPix(<mm2D>new THREE.Vector2(dir.x * 1000, dir.z * 1000));
                const mm = <mm2D>new THREE.Vector2(pointList[index].point.x * 1000 + dir.x / 2 * 1000, pointList[index].point.z * 1000 + dir.z / 2 * 1000);
                info.x = Math.round(center2D.x + Unit.convertMmtoPix(mm).x);
                info.y = Math.round(center2D.y - Unit.convertMmtoPix(mm).y);
                
                /** 幅 **/
                const width = pix.clone().length();
                info.width = Math.round(width);
                info.widthmm = Math.round(dir.clone().length() * 1000);
                walls.push(info);
            }

            marietta.webcad.util.WebcadJSONParser.reproduceCommonItem(walls, 'fitting');
        }
    }
    
    /**
     * マンション 壁オブジェクト座標
     * */
    private createShape = (pointList: PointInfo[], index: number, next: number): shapeType[] => {
        const center2D = new THREE.Vector2(marietta.webcad.WebCADGlobal.LAYER_SIZE_W/2, marietta.webcad.WebCADGlobal.LAYER_SIZE_H/2);
        const pix = <pix2D>new THREE.Vector2(center2D.x, center2D.y);
        const mm = <mm2D>new THREE.Vector2(pointList[index].point.x * 1000, pointList[index].point.z * 1000);
        const shape: shapeType[] = [];
        shape.push({
            x: Math.round(mm.x + Unit.convertPixtoMm(pix).x),
            y: Math.round(Unit.convertPixtoMm(pix).y - mm.y),
            wall_type: NaN
        });
        const mm_ = <mm2D>new THREE.Vector2(pointList[next].point.x * 1000, pointList[next].point.z * 1000);
        shape.push({
            x: Math.round(mm_.x + Unit.convertPixtoMm(pix).x),
            y: Math.round(Unit.convertPixtoMm(pix).y - mm_.y),
            wall_type: NaN
        });

        return shape;
    }
    
    /** 戸建て 角度 算出 **/
    private getRotate = (pointList: PointInfo[], index: number): number => {
        const dir = pointList[Point.nextPoint(index)].point.clone().sub(pointList[index].point);
        const normalize = new THREE.Vector2(dir.x, dir.z).normalize();
        const rad = normalize.clone().angle();
        const rotation = THREE.MathUtils.radToDeg(rad);

        return rotation;
    }

    /**
     * 頂点リスト作成
     * */
    private createDotList(point: THREE.Vector3, wallType: number): marietta.webcad.collection.PointCollection {
        const mm = <mm2D>new THREE.Vector2(point.x * 1000, point.z * 1000);
        const x = Unit.convertMmtoPix(mm).x;
        const y = Unit.convertMmtoPix(mm).y;
        const dot: marietta.webcad.collection.PointCollection = new marietta.webcad.collection.PointCollection(x, y, wallType);
        dot.guid = marietta.webcad.WebCADGlobal.getGuid();

        return dot;
    }

}